module.exports = __webpack_public_path__ + "img/icon-plant-configured.35b6468f.svg";